import React, { useEffect } from 'react'
import { useLocation, Outlet, ScrollRestoration } from 'react-router-dom'
// @mui
import {
	Box, Link, Container, Typography, Stack,
} from '@mui/material'
// components
import NewsHeader from './NewsHeader'

// ----------------------------------------------------------------------

export default function MainLayout() {
	const { pathname } = useLocation()

	const isHome = pathname === '/'

	useEffect(() => {
		// console.log('do hubspot cleanup')
		document.querySelector('script[id="hs-script-loader"]')?.remove()
		document.querySelector('script[id="hubspot-messages-loader"]')?.remove()
		document.querySelector('script[src="https://js.hs-banner.com/v2/23310038/banner.js"]')?.remove()
		document.querySelector('script[src="https://js.hscollectedforms.net/collectedforms.js"]')?.remove()
		document.querySelector('div[id="hubspot-messages-iframe-container"]')?.remove()
	}, [])

	return (
		<>
			<Stack sx={{ minHeight: 1 }}>
				<NewsHeader />

				<Outlet />

				<Box sx={{ flexGrow: 1 }} />

			</Stack>
			{/* <ScrollRestoration getKey={(location, matches) => location.pathname} /> */}
		</>
	)
}
